import {
  Drupal,
  FileConnection,
  Drupal_Metatag,
  Drupal_Node,
  DemoRequestClientsJsonConnection,
  EnterpriseHeaderLogosJsonConnection,
  ProductTemplatesJsonConnection,
  MarketoForm,
  Maybe,
  Scalars,
  Drupal_ParagraphMarketoForm
} from '../generated/graphql';

export interface IPageContext {
  nid: string;
  langPrefix: string;
  LanguageId: string;
  i18nKey: string;
  pageType: string;
  extraData: string;
  page?: number;
  pageCount?: number;
  pageSize?: number;
  hubAlias?: string;
  excludeFromSitemap?: boolean;
}

export interface ITemplateProps {
  data: {
    drupal: Drupal;
    i18nData?: FileConnection;
    allDemoRequestClientsJson?: DemoRequestClientsJsonConnection;
    allEnterpriseHeaderLogosJson?: EnterpriseHeaderLogosJsonConnection;
    allProductTemplatesJson?: ProductTemplatesJsonConnection;
  };
  pageContext: IPageContext;
  location: any;
}

export interface ExtraData {
  marketoForms: { [key: string]: MarketoForm };
  metatags: Drupal_Metatag[];
  otherTranslationData: Drupal_Node[];
  navbarMenu: any;
  footerMenu: any;
}

export interface MarketoFormField {
  targetId?: Maybe<Scalars['Int']>;
  entity?: Maybe<Drupal_ParagraphMarketoForm>;
  targetRevisionId?: Maybe<Scalars['Int']>;
}

export function isDefined<T extends object>(
  input: null | undefined | T | string
): input is T {
  return input != null;
}

export enum Template {
  CaseStudy = 'case_study',
  CaseStudyHub = 'case_study_hub',
  Consideration = 'consideration',
  ConsiderationCompetitor = 'consideration-competitor',
  ConsiderationCompetitorPpc = 'consideration-competitor-ppc',
  ConsiderationPpc = 'consideration_ppc',
  DemoRequest = 'demo_request',
  Discovery = 'discovery',
  Documentation = 'documentation',
  Ebook = 'ebook',
  Enterprise = 'enterprise',
  EnterpriseRegistration = 'enterprise_registration',
  FifteenCompetitor = 'fifteen_competitor',
  FifteenIntegration = 'fifteen_integration',
  FifteenIntegrationPpc = 'fifteen_integration_ppc',
  FifteenOg = 'fifteen_og',
  FifteenOgCompetitor = 'fifteen_og_competitor',
  FifteenOgPpc = 'fifteen_og_ppc',
  FormPage = 'form_page',
  FunFlowchart = 'fun_flowchart',
  FunFlowchartHub = 'fun_flowchart_hub',
  Homepage = 'homepage',
  IndividualRole = 'individual_role',
  IntegrationHub = 'integration_hub',
  Nineteen = 'nineteen',
  Partners = 'partners',
  ProductTemplate = 'product_template',
  ProductTemplateHub = 'product_template_hub',
  RolesHub = 'roles_hub',
  SolutionsHub = 'solutions_hub',
  Sunrise = 'sunrise',
  TourPage = 'tour_page',
  Webinar = 'webinar',
  WebinarHub = 'webinar_hub',
  WhitePaper = 'white_paper'
}

export enum WeekDay {
  Sunday = 0,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday
}

declare global {
  interface Window {
    _wq: any;
    drift: any;
    Wistia: any;
    lucid: any;
  }
}
